var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwLineCsps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 581 47.8",
    style: {
      enableBackground: "new 0 0 581 47.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#006D7F;}\n\t.st1{fill:#003E4C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000182504219777550222810000018172375190508952704_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M525.6,41.3H37.5c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h488.1c1.9,0,3.5,1.6,3.5,3.5S527.6,41.3,525.6,41.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,41.6V20.2h6.3c1.1,0,2.2,0.2,3.1,0.8c0.8,0.5,1.4,1.2,1.8,2c0.4,1,0.6,2.2,0.6,3.3c0,1.2-0.2,2.3-0.7,3.4 c-0.4,0.8-1.1,1.5-2,1.9c-0.9,0.4-2,0.6-3,0.6H3.9v9.5L0,41.6z M3.9,29.4h1.5c0.6,0,1.1-0.1,1.6-0.3c0.4-0.2,0.7-0.6,0.8-1 C8,27.5,8.1,26.9,8,26.2c0-0.6,0-1.3-0.2-1.9c-0.1-0.4-0.4-0.8-0.7-1.1C6.6,23.1,6,22.9,5.4,23H3.9V29.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.3,47.5V37.2c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.3,0.1-0.5,0.2s-0.3,0.1-0.5,0.2 c-0.2,0.1-0.3,0.1-0.4,0.2v-2c0.1-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.4-0.2,0.7-0.4c0.2-0.1,0.5-0.3,0.7-0.4c0.2-0.1,0.4-0.3,0.5-0.4 H17v13H14.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwLineCsps);
export default __webpack_public_path__ + "static/media/SwLine-CSPS.3ed8e05b6163414e8291cde41f40cf82.svg";
export { ForwardRef as ReactComponent };